import React, { useState } from "react";
import { Mic, Headphones, Video, Check, Calendar } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { message } from "antd";
import ModalCitasCliente from "../../../../components/elements/ModalCitasCliente";

export default function Podcast() {
  const navigate = useNavigate();

  const { podcast } = useSelector((state) => state.clientes);

  const [selectedAppointment, setSelectedAppointment] = useState({
    day: null,
    time: null,
  });

  const [messageApi, contextHolder] = message.useMessage();
  const [isModalOpen, setIsModalOpen] = useState(false);


  const success = () => {
    messageApi.open({
      type: "success",
      content: "Evento agregado correctamente!",
    });
  };

  const genericError = (text) => {
    messageApi.open({
      type: "error",
      content: text,
    });
  };

  const handleTimeSelect = (day, time) => {
    setSelectedAppointment({ day, time });
    console.log("Cita seleccionada:", { day, time });
  };

  const services = [
    {
      title: "Sesiones por Hora",
      icon: <Video size={20} className="text-blue-500" />,
      description:
        "Reserva el estudio por hora para grabar podcasts, entrevistas o contenido en video con la mejor calidad de producción.",
    },
    {
      title: "Cámaras",
      icon: <Video size={20} className="text-green-500" />,
      description:
        "Utilizamos cámaras de alta gama para capturar contenido en resolución Full HD o 4K.",
    },
    {
      title: "Audio",
      icon: <Headphones size={20} className="text-purple-500" />,
      description:
        "Sonido de máxima calidad con micrófonos profesionales y procesamiento de audio en tiempo real.",
    },
    {
      title: "Tu Episodio en 48 Horas",
      icon: <Check size={20} className="text-yellow-500" />,
      description:
        "Entrega garantizada en 48 horas con edición lista para ser publicada.",
    },
    {
      title: "Integración de Títulos",
      icon: <Video size={20} className="text-pink-500" />,
      description:
        "Añadimos títulos, nombres de invitados, temas y cualquier otro texto relevante en pantalla.",
    },
    {
      title: "Branding Estudio",
      icon: <Check size={20} className="text-teal-500" />,
      description:
        "Personalización del set con los colores, logos y elementos visuales de tu marca.",
    },
    {
      title: "Reels",
      icon: <Video size={20} className="text-orange-500" />,
      description:
        "Creamos cortes estratégicos en formato vertical (9:16) con los mejores momentos de tu episodio.",
    },
    {
      title: "Grabación en Ubicación Externa",
      icon: <Mic size={20} className="text-indigo-500" />,
      description:
        "Llevamos nuestra producción a cualquier lugar que el cliente necesite.",
    },
  ];

  return (
    <div className="bg-background min-h-[91.5vh] w-full px-6 sm:px-10 font-poppina">
      {contextHolder}

      <ModalCitasCliente
      isModalOpen={isModalOpen}
      setIsModalOpen={setIsModalOpen}
      success={success}
      genericError={genericError}
      />

      <div className="mt-2 text-gray-500 sm:text-base text-sm flex items-center">
        <p onClick={() => navigate("/client")} className="mr-4 text-subtitle hover:text-text cursor-pointer ">
          Cuenta
        </p>
        <p>{">"}</p>
        <p className="mx-4 text-text ">Podcast: {podcast.name} </p>
      </div>

      <div className="mt-5">
        <h1 className="text-text text-center text-5xl uppercase font-semibold " >{podcast.name}</h1>
      </div>
      {podcast.monthlyPlan === true || podcast.planActive === true ? (
        <div className="contenedor" >
        <div className="flex flex-col sm:flex-row gap-6 mt-10">
          <div className="bg-background shadow-xl h-[350px] rounded-2xl p-8 flex-1 transform transition-all hover:shadow-2xl border border-gray-100 dark:border-gray-700">
            <div className="flex  items-center mb-6">
              <div className="p-3 bg-blue-50 dark:bg-blue-900 rounded-lg">
                <Mic className="text-blue-500 dark:text-blue-300" size={32} />
              </div>
              <h2 className="text-2xl font-bold text-gray-800 dark:text-white ml-4">
                Pago por Uso
              </h2>
            </div>
            <p className="text-lg text-gray-600 dark:text-gray-300 mb-4">
              (Para Nuevos Clientes o Pruebas)
            </p>
            <p className="text-gray-700 dark:text-gray-400 mb-8">
              Ideal para clientes que quieren probar antes de comprometerse con
              una membresía.
            </p>
            <button
              onClick={() => navigate("/client/pago-por-uso")}
              className="bg-blue-500 text-white px-8 py-3 rounded-xl text-lg font-semibold hover:bg-blue-600 transition-colors w-full"
            >
              Seleccionar
            </button>
          </div>
  
          <div className="bg-background shadow-xl rounded-2xl p-8 flex-1 transform transition-all hover:shadow-2xl border border-gray-100 dark:border-gray-700">
            <div className="flex items-center mb-6">
              <div className="p-3 bg-green-50 dark:bg-green-900 rounded-lg">
                <Headphones
                  className="text-green-500 dark:text-green-300"
                  size={32}
                />
              </div>
              <h2 className="text-2xl font-bold text-gray-800 dark:text-white ml-4">
                Membresías Mensuales
              </h2>
            </div>
            <p className="text-lg text-gray-600 dark:text-gray-300 mb-4">
              (Clientes Frecuentes)
            </p>
            <p className="text-gray-700 dark:text-gray-400 mb-8">
              Para creadores comprometidos que producen contenido con constancia.
            </p>
            <button
              onClick={() => navigate("/client/membresia")}
              className="bg-green-500 text-white px-8 py-3 rounded-xl text-lg font-semibold hover:bg-green-600 transition-colors w-full"
            >
              Seleccionar
            </button>
          </div>
        </div>
  
        <div className="mt-10">
          <h1 className="text-3xl font-semibold text-gray-800 dark:text-white">
            Servicios de Harma Studio
          </h1>
        </div>
  
        <div className="mt-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {services.map((service, index) => (
              <div key={index} className="flex items-start space-x-3">
                <div className="flex-shrink-0">
                  <div className="p-2 bg-gray-50 dark:bg-gray-700 rounded-lg">
                    {service.icon}
                  </div>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-800 dark:text-white">
                    {service.title}
                  </h3>
                  <p className="text-sm text-gray-600 dark:text-gray-300">
                    {service.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
  
        </div>
      ) : (
        <div>
          <div
          onClick={() => setIsModalOpen(true)}
          className="absolute bg-white top-5 px-4 py-2 rounded-lg right-10 flex items-center transition duration-300 ease-in-out transform hover:scale-105 space-x-2 shadow-md cursor-pointer"
        >
          <Calendar className="w-6 h-6 text-blue-500" />
          <button className="text-blue-500 font-semibold text-lg">
            <p className="sm:block hidden">Agenda una cita</p>
          </button>
        </div>
      </div>

      )}

      

    </div>
  );
}
